import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { AvInput } from "availity-reactstrap-validation"
import { Col, FormGroup, Label, Row } from "reactstrap"
import SelectWithInput from "../../../../../../components/Common/SelectWithInput"

const _options = [
  {
    label: "Create split test",
    key: "createSplitTest",
    description: "Get more insight into your ads by split testing your strategy."
  },
  {
    label: "Campaign budget optimization",
    key: "campaignBudgetOptimization",
    description: "Automatically optimize your budget allocation. You'll have some limitations on your bid strategy and optimization goal."
  }
]

const options_budget = [
  {label: "Daily", value: 'daily'},
  {label: "Lifetime", value: 'lifetime'},
]

/*
*
* @param onClick() : (item: typeof options[0] | null) => void
* */
const SplitOrOptimization = ({ onChange, value, items }) => {

  const handleClick = (e, i) => {

    /*const initial = {
      [options[0].key]: false,
      [options[1].key]: false,
    }

    initial[i.key] = e.target.checked*/

    onChange({
      // initial
      [_options[0].key]: false,
      [_options[1].key]: false,

      // change
      [i.key]: e.target.checked
    })

    // if (e.target.checked) {
    //   // setValue(i)
    //
    // } else if (i === value) {
    //   // setValue(null)
    //   onClick(initial)
    // }
  }
  const active = React.useMemo(() => (value[_options[0].key] ? _options[0].key : value[_options[1].key] ? _options[1].key : false), [value])

  const options = React.useMemo(() => {
    const data = _options.filter(o => items.some(i => i === o.key))

    if (active && !data.find(i => i.key === active)) {
      onChange({
        [_options[0].key]: false,
        [_options[1].key]: false,
      })
    }

    return data
  }, [items])

  return (
    <SplitOrOptimizationStyled>
      {options?.map(i => {
        const disabled = active === false ? false : active !== i.key

        return (
          <React.Fragment key={i.key}>
            <div
              className="form-check form-switch form-switch-md"
            >
              <AvInput
                name={i.key}
                type="checkbox"
                className="form-check-input"
                id={i.key}
                checked={i.key === active}
                onChange={(e) => handleClick(e, i)}
                disabled={disabled}
              />
              <label
                className="form-check-label"
                htmlFor={i.key}
              >{i.label}</label>
            </div>
            <p className="text-muted mb-4" style={{opacity: disabled ? '.5' : '1'}}>{i.description}</p>
            {/*{i.key === active && <>*/}
            {/*  {i.key === "campaignBudgetOptimization" && <div>*/}
            {/*    <Row>*/}
            {/*      <Col md={6}>*/}
            {/*        <FormGroup className="mb-3">*/}
            {/*          <Label htmlFor="">Budget (USD):</Label>*/}
            {/*          <SelectWithInput*/}
            {/*            select_name={"campaign-budget-optimization_type"}*/}
            {/*            options={options_budget}*/}
            {/*            defaultValue={options_budget[0]}*/}
            {/*            required*/}
            {/*            // isLoading={isLoading}*/}
            {/*            inputOptions={{*/}
            {/*              name: "campaign-budget-optimization",*/}
            {/*              placeholder: "Al least 50.00",*/}
            {/*              value: "",*/}
            {/*              type: "number",*/}
            {/*              errorMessage: "Budget field is required!",*/}
            {/*              validate: { required: { value: true } },*/}
            {/*            }}*/}
            {/*          />*/}
            {/*        </FormGroup>*/}
            {/*      </Col>*/}
            {/*    </Row>*/}
            {/*  </div>}*/}
            {/*</>}*/}
          </React.Fragment>
        )
      })}
    </SplitOrOptimizationStyled>
  )
}

SplitOrOptimization.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.object,
  items: PropTypes.array,
}

const SplitOrOptimizationStyled = styled.div`
`

export default (SplitOrOptimization)
